function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.75 2.51909L15.9875 0.756592L9 7.74409L2.0125 0.756592L0.25 2.51909L7.2375 9.50659L0.25 16.4941L2.0125 18.2566L9 11.2691L15.9875 18.2566L17.75 16.4941L10.7625 9.50659L17.75 2.51909Z",
  fill: "#1C73FF"
});
const SvgCross = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cross.14672e7c.svg";
export { ForwardRef as ReactComponent };